import styled from 'styled-components'
import dynamic from 'next/dynamic'

import MainLayout from '../../layouts/MainLayout'
import ActionButton from '../../components/ActionButton'
import SectionWrapper from '../../components/SectionWrapper'
import BannerTitleTextButton from '../../components/BannerTitleTextButton'
import AdsSortingFilters from '../../components/AdsSortingFilters'
import AdsGrid from '../../components/AdsGrid'
import { mq, sizes } from '../../theme'
import Pagination from '../../components/Pagination'

const Map = dynamic(() => import('../../components/Map'), { ssr: false })

export const Layout = styled(MainLayout)`
  main {
    margin-top: 0;
  }
`

export const FiltersBanner = styled(AdsSortingFilters)``

export const Error = styled.div`
  ${({ theme }) => theme.textStyles.bebas2Xl}
  color: ${({ theme }) => theme.colors.arapawa};
  padding: 2rem;
  text-align: center;
  width: 100%;
`

export const Overflow = styled.div`
  width: 100%;
  overflow: auto;
`

export const List = styled.div`
  padding: 4rem 0 0 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  overflow: auto;

  @media ${mq(sizes.tablet)} {
    display: table;
    width: 100%;
    border-spacing: 0 2.5rem;
  }
`

export const GridAds = styled(AdsGrid)``
export const MapWrapper = styled.div`
  position: relative;
  &::after {
    content: '';
    display: block;
    padding-top: 60%;
  }
`

export const MapAds = styled(Map)`
  position: absolute;
`

export const SeeMoreButton = styled(ActionButton)``

export const Centered = styled(SectionWrapper)`
  text-align: center;
  margin-bottom: 6rem;
`

export const InfoBanner = styled(BannerTitleTextButton)``

export const PaginationStyled = styled(Pagination)`
  justify-content: center;
`
